import React from 'react';
import PropTypes from 'prop-types';
import FullPageMessage from '../../../common/fullPageMessage/FullPageMessage';
import {
	ONBOARDING_UPDATED_PASSWORD_TITLE,
	ONBOARDING_UPDATED_PASSWORD_CTA,
	ONBOARDING_UPDATED_PASSWORD_DESCRIPTION,
} from '../../../../constants/Copy';
import { ROUTE_LOGIN_EMAIL } from '../../../../constants/Routes';

const PasswordUpdated = ({ loading, onClick }) => {
	return (
		<FullPageMessage
			button={{
				loading,
				onClick,
				testValue: ROUTE_LOGIN_EMAIL,
				text: ONBOARDING_UPDATED_PASSWORD_CTA,
			}}
			title={ONBOARDING_UPDATED_PASSWORD_TITLE}
			description={ONBOARDING_UPDATED_PASSWORD_DESCRIPTION}
		/>
	);
};

PasswordUpdated.propTypes = {
	onClick: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
};

export default PasswordUpdated;
